import { orders } from "../endpoints/orders.endpoints";
import $axios from "../http/accessor";

const OrderService = {
  getAllOrders: (
    page: number,
    count: number,
    status: string,
    currencyId?: number | null,
  ) => {
    const params: any = {
      page,
      count,
      status,
    };
    if (currencyId) {
      params.currency_id = currencyId;
    }
    return $axios.get(orders.orders, { params });
  },

  chageStatus: (id: number) => {
    return $axios.put(orders.change_status(id));
  },

  getAllPayments: (page: number, count: number) => {
    return $axios.get(orders.get_all_payments, {
      params: {
        page,
        count,
      },
    });
  },
};

export default OrderService;
